module.exports = __webpack_public_path__ + "static/media/mini.d7ad5d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程GLR增程式冷藏车/mini.png
// module id = 702
// module chunks = 0